import { Component, OnInit, AfterViewInit } from '@angular/core';
import { setTheme } from 'ngx-bootstrap/utils';
import { Angulartics2GoogleGlobalSiteTag } from 'angulartics2/gst';
import { AppSettings } from './services/app-settings.service';
import { NavigationStart, Router } from '@angular/router';
import { NotificationService } from './core/services/Common/notification.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']

})
export class AppComponent implements OnInit, AfterViewInit {
	title = 'sa';

	confirmDialogData: any;
	toastData: any;
	// constructor(angulartics: Angulartics2GoogleGlobalSiteTag) {
	//   angulartics.startTracking(); // Google Analytics Detailed tracking

	// }
	constructor(private router: Router, public appSettings: AppSettings, private notificationService: NotificationService) {
		// setTheme('bs3'); // or 'bs4'
		router.events.subscribe((e) => {
			if (e instanceof NavigationStart) {
				if (window.innerWidth < 768) {
					this.appSettings.appSidebarMobileToggled = false;
					this.appSettings.appSidebarEndMobileToggled = false;
				}
			}
		});

		this.notificationService.confirmDialog$.subscribe(data => {
			this.confirmDialogData = data;
		});

		this.notificationService.toast$.subscribe(data => {
			this.toastData = data;
		});
		// new code for cache clear
		//this.initializeCache().catch(err => console.error('Cache initialization failed:', err));
		//

	}

	ngOnInit() {

		if (localStorage) {

			if (localStorage['appHeaderFixed']) {
				this.appSettings.appHeaderFixed = (localStorage['appHeaderFixed'] === 'true') ? true : false;
			}
			if (localStorage['appHeaderInverse']) {
				this.appSettings.appHeaderInverse = (localStorage['appHeaderInverse'] === 'true') ? true : false;
			}
			if (localStorage['appSidebarFixed']) {
				this.appSettings.appSidebarFixed = (localStorage['appSidebarFixed'] === 'true') ? true : false;
			}
			if (localStorage['appSidebarMinified']) {
				this.appSettings.appSidebarMinified = (localStorage['appSidebarMinified'] === 'true') ? true : false;
			}
			if (localStorage['appSidebarGrid']) {
				this.appSettings.appSidebarGrid = (localStorage['appSidebarGrid'] === 'true') ? true : false;
			}
			if (localStorage['appGradientEnabled']) {
				this.appSettings.appGradientEnabled = (localStorage['appGradientEnabled'] === 'true') ? true : false;
			}
		}

	}
	private async initializeCache(): Promise<void> {
		if (!sessionStorage.getItem('cacheCleared')) {
			await this.clearAppCache();
			sessionStorage.setItem('cacheCleared', 'true');
		} else {
			// Optionally, check cache size and clear if > 1GB
			const size = await this.getAppCacheSize();
			if (size > 1024 * 1024 * 1024) { // 1GB Slight return; // 1GB in bytes
				await this.clearAppCache();
			}
		}
	}
	//#region  cacheclear
	async clearAppCache() {
		localStorage.clear();
		sessionStorage.clear();
		// Clear IndexedDB
		await this.clearAllIndexedDB();
		// Optionally, clear cookies set by your app
		this.clearAppCookies();
		console.log('App cache cleared');
	}

	async getAppCacheSize(): Promise<number> {
		let total = 0;
		// localStorage
		for (let key in localStorage) {
			if (localStorage.hasOwnProperty(key)) {
				total += (localStorage[key]?.length || 0);
			}
		}
		// sessionStorage
		for (let key in sessionStorage) {
			if (sessionStorage.hasOwnProperty(key)) {
				total += (sessionStorage[key]?.length || 0);
			}
		}
		// IndexedDB (estimate)
		if (window.indexedDB) {
			const dbs = await indexedDB.databases?.() || [];
			for (const db of dbs) {
				// No direct way to get size, so just count DBs
				total += 1024 * 1024; // Assume 1MB per DB as a rough estimate
			}
		}
		return total;
	}

	async clearAllIndexedDB() {
		if (window.indexedDB && indexedDB.databases) {
			const dbs = await indexedDB.databases();
			for (const db of dbs) {
				if (db.name) indexedDB.deleteDatabase(db.name);
			}
		}
	}

	clearAppCookies() {
		// Only clears cookies for current domain and path
		document.cookie.split(";").forEach((c) => {
			document.cookie = c
				.replace(/^ +/, "")
				.replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
		});
	}
	//#endregion
	ngAfterViewInit() {

	}
	onActivate(e) {

	}
	onDialogClosed(buttonPressed: string) {
		if (this.confirmDialogData?.callback) {
			this.confirmDialogData.callback(buttonPressed);
		}
		this.confirmDialogData = null;
	}
}
